interface Props {
  status: string;
}

const statusConfig: Record<string, { color: string; label: string; icon: string }> = {
  active: { color: 'green', label: 'Active', icon: '●' },
  paused: { color: 'yellow', label: 'Paused', icon: '●' },
  deleted: { color: 'gray', label: 'Deleted', icon: '●' },
  archived: { color: 'gray', label: 'Archived', icon: '●' },
};

const colorClasses: Record<string, string> = {
  green: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
  yellow: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
  gray: 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400',
};

export function StatusBadge({ status }: Props) {
  const config = statusConfig[status.toLowerCase()] || statusConfig.active;
  const classes = colorClasses[config.color];

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${classes}`}>
      <span className="mr-1">{config.icon}</span>
      {config.label}
    </span>
  );
}
